module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dm-box"
  }, [_c('div', {
    staticClass: "inRoomUser-box-div"
  }, _vm._l((_vm.inUserList), function(item, index) {
    return _c('div', {
      key: ("user-" + index),
      staticClass: "inRoomUser-box dm-slide-in",
      style: ({
        zIndex: 10 - index
      })
    }, [_c('span', {
      staticClass: "inRoomUser-box-text"
    }, [_vm._v(_vm._s(item.name) + "：")]), _vm._v(" "), _c('span', {
      staticClass: "inRoomUser-box-text1"
    }, [_vm._v(_vm._s(_vm.$t('all.jinrulezhibojian')))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dm-box-container"
  }, [_c('div', {
    ref: "danmuContainer",
    staticClass: "dm-box-container-list"
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dm-box-container-list-item"
    }, [_c('div', {
      staticClass: "dm-box-container-list-item-box",
      on: {
        "click": function($event) {
          return _vm.handleShowUser(item)
        }
      }
    }, [_c('div', {
      staticClass: "dm-content-wrapper"
    }, [(item.sendUserInfo) ? _c('span', {
      staticClass: "dm-box-container-list-item-text1"
    }, [_vm._v(_vm._s(item.sendUserInfo.nickName) + "：")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "dm-content-text"
    }, [(item.type == -1) ? [_c('img', {
      staticClass: "xiaolapa",
      attrs: {
        "src": require("../../assets/image/xlp.png"),
        "alt": ""
      }
    })] : _vm._e(), _vm._v(" "), (!item.sendUserInfo) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text"
    }, [_vm._v(_vm._s(item.title))])] : _vm._e(), _vm._v(" "), (item.type == 3) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text2"
    }, [_vm._v(_vm._s(item.title))])] : _vm._e(), _vm._v(" "), (item.type == 1) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text3"
    }, [_vm._v(_vm._s(item.title))])] : _vm._e(), _vm._v(" "), (item.type == 12) ? [_c('span', {
      staticClass: "dm-box-container-list-item-text2"
    }, [_vm._v(_vm._s(_vm.$t('all.songgei')) + _vm._s(item.toUserInfo.nickName) + _vm._s(item.giftInfo.content))]), _vm._v(" "), _c('img', {
      staticClass: "danmaku-body-item-box-img",
      attrs: {
        "src": item.giftInfo.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dm-box-container-list-item-text2"
    }, [_vm._v("×" + _vm._s(item.num))])] : _vm._e()], 2)])])])
  }), 0), _vm._v(" "), (_vm.show_kjdy && _vm.kjdyList.length > 0) ? _c('div', {
    staticClass: "dm-box-kjdy"
  }, [_vm._l((_vm.kjdyList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dm-box-kjdy-item",
      on: {
        "click": function($event) {
          return _vm.handleFsKjdy(item.content)
        }
      }
    }, [_vm._v(_vm._s(item.content))])
  }), _vm._v(" "), _c('img', {
    staticClass: "closeKjdy",
    attrs: {
      "src": require("../../assets/image/x_22_1@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show_kjdy = false
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dm-box-textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.content),
      expression: "form.content"
    }],
    attrs: {
      "placeholder": _vm.$t('all.shuodianshenmene'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.content)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnter.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f97f135"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/danmu/danmu.vue
// module id = 826
// module chunks = 1